
angular.module('zeppelinWebApp').controller('PasswordResetCtrl', PasswordResetCtrl);

function PasswordResetCtrl($scope, $route, $routeParams, $rootScope, $http, $httpParamSerializer,
                           baseUrlSrv, $location, $timeout) {
  'ngInject';

  $scope.updatingPass = false;
  $scope.passwordResetParams = {};

  $scope.updatePassword = function() {
    $scope.updatingPass = true;
    $scope.passwordResetParams.successText = '';
    $scope.passwordResetParams.errorText = '';
    if ($scope.passwordResetParams.newPass === $scope.passwordResetParams.confirmNewPass) {
      $http({
        method: 'PUT',
        url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset/' + $routeParams.token,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          'newPassword': $scope.passwordResetParams.newPass,
        }),
      }).then(function successCallback(response) {
        $scope.updatingPass = false;
        if (!$rootScope.ticket) {
          $location.path('/');
          angular.element('#loginModal').modal('toggle');
          $rootScope.$broadcast('passwordResetSuccess');
        } else {
          $scope.passwordResetParams.successText = 'Password successfully updated.';
        }
      }, function errorCallback(errorResponse) {
        $scope.passwordResetParams.errorText = errorResponse.data.message;
        $scope.updatingPass = false;
      });
    } else {
      $scope.updatingPass = false;
      $scope.passwordResetParams.errorText = 'Passwords must match';
    }
  };

  $scope.initPasswordReset = function() {
    $scope.passwordResetParams = {
      containsValidToken: false,
      hasLoaded: false,
      newPass: '',
      confirmNewPass: '',
      successText: '',
      errorText: '',
    };

    console.log('validating password reset token.');
    $http({
      method: 'GET',
      url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset/' + $routeParams.token,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function successCallback(response) {
      $scope.passwordResetParams.hasLoaded = true;
      $scope.passwordResetParams.containsValidToken = true;
    }, function errorCallback(errorResponse) {
      $scope.passwordResetParams.hasLoaded = true;
      $scope.passwordResetParams.containsValidToken = false;
      if (errorResponse && errorResponse.data && errorResponse.data.message) {
        $scope.passwordResetParams.errorText = errorResponse.data.message;
      } else {
        $scope.passwordResetParams.errorText = 'The Magpie password reset service has hit a snag. Please try again.';
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/password-reset/password-reset.controller.js